import { Alert, Button, Card, Col, Divider, Empty, List, Row, Select, Space, Spin, Statistic, Table } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { CompanyProductVersionModel, Feature } from '../../models/product-interface';
import Search from 'antd/lib/input/Search';
import { Link } from 'react-router-dom';
import { Company } from '../../models/company-interface';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import MeetingsUsage from './Usage/MeetingsUsage';
import AdminUsage from './Usage/AdminUsage';
import MemberUsage from './Usage/MemberAppUsage';
import UsersUsage from './Usage/UsersUsage';
import DashboardsUsage from './Usage/DashboardsUsage';
import TopicsUsage from './Usage/TopicsUsage';
import CommitteeSuiteUsage from './Usage/CommitteeSuiteUsage';
import MinutesUsage from './Usage/MinutesUsage';
import SurveysUsage from './Usage/SurveysUsage';
import VotesUsage from './Usage/VotesUsage';
import ESignUsage from './Usage/ESignUsage';
import IntegrationsUsage from './Usage/IntegrationsUsage';
import MS365Usage from './Usage/MS365Usage';
import FileCopyUsage from './Usage/FileCopyUsage';
import GabiiUsage from './Usage/GabiiUsage';
import SearchUsage from './Usage/SearchUsage';

const { Option } = Select;

interface CompanyUsageTabProps {
  products: CompanyProductVersionModel[] | undefined;
  company: Company | undefined;
  demoFeatures: Feature[] | undefined;
  demoCompany: boolean;
  isLoading: boolean;
}

interface CompanyFeature {
  id: number;
  name: string;
  products: CompanyProductVersionModel[];
  isOnDemo: boolean;
  allowLimit: boolean;
  recordLimit: number;
}

export function CompanyUsageTab({ products, company, isLoading, demoFeatures, demoCompany }: CompanyUsageTabProps) {

  const [usage,setUsage] = useState("all")
  useEffect(() => {
    
  },[])

  
  const allFeatures = ():Feature[] =>  {
    var features:Feature[] = []
    products?.forEach(p => {
        p.features.forEach(pf => {
            if(!features.some(f => f.id == pf.id)) {
                features.push(pf)
            } else {
                var existing = features.find(f => f.id == pf.id)
                
                if(existing.recordLimit > 0 && (pf.recordLimit == 0 || pf.recordLimit > existing.recordLimit)) {
                    if(pf.recordLimit !== 0 && existing.recordLimit !== 0) {
                        existing.recordLimit = existing.recordLimit + pf.recordLimit
                    } else {
                        existing.recordLimit = pf.recordLimit
                    }
                }
            }
        })
    })

    if(!!demoFeatures && demoCompany) {
      demoFeatures.forEach(pf => {
        if(!features.some(f => f.id == pf.id)) {
          features.push(pf)
        } else {
            var existing = features.find(f => f.id == pf.id)
            
            if(existing.recordLimit > 0 && (pf.recordLimit == 0 || pf.recordLimit > existing.recordLimit)) {
                if(pf.recordLimit !== 0 && existing.recordLimit !== 0) {
                    existing.recordLimit = existing.recordLimit + pf.recordLimit
                } else {
                    existing.recordLimit = pf.recordLimit
                }
            }
        }
      })
    }

    return features
  }

  const handleChange = (value: string) => {
    setUsage(value)
  };

  return (
    <Spin spinning={isLoading}>
      {company !== null && company?.id !== undefined && 
      <Row gutter={[16,16]}>
        <Col span={24}>
        <Select
      defaultValue={usage}
      style={{ width: 240 }}
      onChange={handleChange}
      loading={isLoading}
      options={[
        {
            value: "all",
            label: 'Show All',
        },
        {
          value: "users",
          label: 'Users',
        },
        {
          value: "admin",
          label: 'Admin Activity',
        },
        {
          value: "member",
          label: 'Member Activity',
        },
        {
          value: "meetings",
          label: 'Meetings',
        },
        {
          value: "minutes",
          label: 'Minutes',
        },
        {
          value: "dashboards",
          label: 'Admin Dashboards',
        },
        {
          value: "topics",
          label: 'Topics',
        },
        {
          value: "committeesuite",
          label: 'Committee Suite',
        },
        {
          value: "surveys",
          label: 'Surveys',
        },
        {
          value: "votes",
          label: 'Votes',
        },
        {
          value: "esign",
          label: 'eSignatures',
        },
        {
          value: "integrations",
          label: 'Integrations',
        },
        {
          value: "ms365",
          label: 'Microsoft 365',
        },
        {
          value: "filecopy",
          label: 'File Copy',
        },
        {
          value: "gabii",
          label: 'Gabii',
        },
        {
          value: "search",
          label: 'Intelligent Search',
        }
      ]}
    />
        </Col>
            {(usage == "all" || usage == "users") && 
            <Col span={24}>
              <UsersUsage
              company={company}
              />
            </Col>}

            {(usage == "all" || usage == "admin") && 
            <Col span={24}>
              <AdminUsage 
                company={company} 
              />
            </Col>}
            
            {(usage == "all" || usage == "member") && 
            <Col span={24}>
              <MemberUsage 
                company={company} 
              />
            </Col>}

            {(usage == "all" || usage == "meetings") && 
            <Col span={24}>
              <MeetingsUsage 
                company={company} 
              />
            </Col>}
            
            {(usage == "all" || usage == "minutes") && 
            <Col span={24}>
              <MinutesUsage 
                company={company} 
              />
            </Col>}

            {(usage == "all" || usage == "dashboards") && 
            <Col span={24}>
              <DashboardsUsage 
                company={company} 
              />
            </Col>}

            {(usage == "all" || usage == "topics") && 
            <Col span={24}>
              <TopicsUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 29)}
              />
            </Col>}

            {(usage == "all" || usage == "committeesuite") && 
            <Col span={24}>
              <CommitteeSuiteUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 31)}
              />
            </Col>}
            
            {(usage == "all" || usage == "surveys") && 
            <Col span={24}>
              <SurveysUsage 
                company={company} 
              />
            </Col>}
            
            {(usage == "all" || usage == "votes") && 
            <Col span={24}>
              <VotesUsage 
                company={company} 
              />
            </Col>}
            
            {(usage == "all" || usage == "esign") && 
            <Col span={24}>
              <ESignUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 9)}
              />
            </Col>}
            
            {(usage == "all" || usage == "integrations") && 
            <Col span={24}>
              <IntegrationsUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 27)}
              />
            </Col>}
            
            {(usage == "all" || usage == "ms365") && 
            <Col span={24}>
              <MS365Usage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 35)}
              />
            </Col>}
            
            {(usage == "all" || usage == "filecopy") && 
            <Col span={24}>
              <FileCopyUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 36)}
              />
            </Col>}

            {(usage == "all" || usage == "gabii") && 
            <Col span={24}>
              <GabiiUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 38)}
              />
            </Col>}

            {(usage == "all" || usage == "search") && 
            <Col span={24}>
              <SearchUsage 
                company={company} 
                hasFeature={allFeatures().some(f => f.id == 40)}
              />
            </Col>}


      </Row>}
      <br/>
    </Spin>
  );
}

